import { TagsDocument } from "@/generated/graphql";
import { useQuery } from "@apollo/client/react";

/**
 * Hook for reading the editor-managed slide taxonomy, already in display order.
 *
 * Archived tags are excluded by default: they must stay resolvable on slides that still
 * carry them, but never appear in a picker.
 *
 * @returns An object containing:
 *   - tags: The tags matching `isArchived`, sorted by sortOrder.
 *   - loading: Boolean indicating if the query is in flight
 */
export function useTags(isArchived = false) {
  const { data, loading } = useQuery(TagsDocument, { variables: { isArchived } });

  return {
    tags: data?.tags ?? [],
    loading,
  };
}
